export default function GreyChip({ label }: { label: string }) {
    return (
        <div
            className={
                'flex h-fit w-fit items-center gap-2.5 rounded-xl bg-black px-2 py-1 text-xs font-bold tracking-tighter text-white'
            }
        >
            {label}
        </div>
    )
}
